export const allSettled = <T = any>(promises: Promise<T>[] | any) => {
  const wrappedPromises = promises.map((p: any) =>
    Promise.resolve(p).then(
      (val) => ({ status: 'fulfilled', value: val }),
      (err) => ({ status: 'rejected', reason: err }),
    ),
  );
  return Promise.all(wrappedPromises);
};
